import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-tiers": "",
  class: "flex flex-col gap-2.5 pl-12"
}
const _hoisted_2 = {
  key: 0,
  class: "m-0 text-sm text-gray-500"
}
const _hoisted_3 = {
  key: 1,
  class: "m-0 text-sm text-gray-600"
}
const _hoisted_4 = {
  key: 1,
  "data-lists": "",
  class: "flex flex-col gap-2.5 pl-12"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_6 = ["aria-label", "onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "m-0 rounded-lg border border-dashed border-gray-300 px-4 py-4 text-sm text-gray-500"
}

import { MenuItem } from '@headlessui/vue'
import { computed, ref } from 'vue'

import InlineSearchSelect from '@/components/InlineSearchSelect.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { AUDIENCE_KINDS, dropLabel, newReminder, nextReminderWhen, sectionCopy } from '@/config/dropWizardSteps'
import { formatDate, formatTime } from '@/helpers/dropWizardDates'
import { reminderSendsAt, reminderSkipReason } from '@/helpers/dropWizardPreview'
import ReminderCard from '@/view/store/dropWizard/ReminderCard.vue'


export default {
  __name: 'StepWho',
  props: { tiers: { type: Array, default: () => [] }, tz: { type: String, default: undefined } },
  setup(__props) {

const props = __props
const wizard = injectWizard()
const audience = computed(() => wizard.data.audience)
const query = ref('')
const results = ref([])

const toggleTier = id => {
  audience.value.tierAudienceIds = audience.value.tierAudienceIds.includes(id)
    ? audience.value.tierAudienceIds.filter(x => x !== id)
    : [...audience.value.tierAudienceIds, id]
}

const addList = item => {
  if (!audience.value.lists.some(list => list.id === String(item.id)))
    audience.value.lists.push({ id: String(item.id), name: item.attributes.audience_name })
  query.value = ''
  results.value = []
}

const removeList = id => {
  audience.value.lists = audience.value.lists.filter(list => list.id !== id)
}

const subscriptionNote = computed(() => {
  if (audience.value.tierAudienceIds.length !== 1) return ''
  const tier = props.tiers.find(t => t.audienceId === audience.value.tierAudienceIds[0])
  return tier?.recurring ? 'Only members whose repeat order falls on these dates are included.' : ''
})

const addReminder = () => wizard.data.reminders.push(newReminder(nextReminderWhen(wizard.data)))

const reminderIds = computed(() => wizard.previewReminderIds?.value ?? [])

// The first open date this reminder actually sends on, from the preview.
const sendsAt = id => {
  const time = reminderSendsAt(wizard.preview.value, reminderIds.value, id)
  return time ? `${formatDate(time, props.tz)}, ${formatTime(time, props.tz)}` : ''
}

const skipReason = id => reminderSkipReason(wizard.preview.value, reminderIds.value, id) ?? ''

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('audience', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "Who can order" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(AUDIENCE_KINDS), (option) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: option.value,
                name: groupName,
                title: option.title,
                subtitle: option.subtitle,
                selected: audience.value.kind === option.value,
                onSelect: $event => (audience.value.kind = option.value)
              }, null, 8, ["name", "title", "subtitle", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }),
        (audience.value.kind === 'tiers')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(SelectionGroup, {
                label: "Memberships",
                mode: "check"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tiers, (tier) => {
                    return (_openBlock(), _createBlock(SelectionCard, {
                      key: tier.audienceId,
                      mode: "check",
                      compact: "",
                      title: tier.name,
                      subtitle: `${tier.count} ${tier.count === 1 ? 'member' : 'members'}`,
                      selected: audience.value.tierAudienceIds.includes(tier.audienceId),
                      onSelect: $event => (toggleTier(tier.audienceId))
                    }, null, 8, ["title", "subtitle", "selected", "onSelect"]))
                  }), 128))
                ]),
                _: 1
              }),
              (!__props.tiers.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, " You have no memberships yet. Everyone or a list works for now. "))
                : _createCommentVNode("", true),
              (subscriptionNote.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(subscriptionNote.value), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (audience.value.kind === 'lists')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (audience.value.lists.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audience.value.lists, (list) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: list.id,
                        class: "inline-flex items-center gap-1 rounded-full border border-gray-300 py-0.5 pl-2.5 pr-1 text-sm text-gray-900"
                      }, [
                        _createTextVNode(_toDisplayString(list.name) + " ", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "rounded-full p-0.5 text-gray-400 hover:text-gray-700",
                          "aria-label": `Remove ${list.name}`,
                          onClick: $event => (removeList(list.id))
                        }, [
                          _createVNode(WizardIcon, { name: "x" })
                        ], 8, _hoisted_6)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(InlineSearchSelect, {
                position: "relative",
                "helper-text": { typingPrompt: 'Add lists', noResult: 'No lists found' },
                "search-endpoint": "audiences/search?included=none",
                "search-request": { search: { text: query.value } },
                onOnSearch: _cache[0] || (_cache[0] = $event => (query.value = $event)),
                onOnResults: _cache[1] || (_cache[1] = $event => (results.value = $event))
              }, {
                searchResults: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(MenuItem), {
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          class: "group w-full rounded-md px-2 py-2 text-left text-sm text-gray-700 transition-colors duration-200 hover:bg-gray-100",
                          onClick: $event => (addList(item))
                        }, _toDisplayString(item.attributes.audience_name), 9, _hoisted_7)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["search-request"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('reminders', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wizard).data.reminders, (reminder, index) => {
          return (_openBlock(), _createBlock(ReminderCard, {
            key: reminder.id,
            reminder: reminder,
            index: index,
            data: _unref(wizard).data,
            "sends-at-label": sendsAt(reminder.id),
            "skip-reason": skipReason(reminder.id),
            "link-example": _unref(wizard).preview.value?.link_example ?? '',
            onUpdate: $event => (Object.assign(reminder, $event)),
            onRemove: $event => (_unref(wizard).data.reminders.splice(index, 1))
          }, null, 8, ["reminder", "index", "data", "sends-at-label", "skip-reason", "link-example", "onUpdate", "onRemove"]))
        }), 128)),
        (!_unref(wizard).data.reminders.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, " No reminders. Customers will only see " + _toDisplayString(_unref(dropLabel)(_unref(wizard).data)) + " on your store. ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(WizardButton, { onClick: addReminder }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("+ Add reminder", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}